// 첫 실행 씨딩용 예시 데이터. 금고를 만들 때 한 번 암호화 저장되고,
// 이후로는 금고(IndexedDB)가 진실의 원천이다. 런타임 컴포넌트는 이 파일을 직접 쓰지 않는다.
export interface Person {
  id: string
  name: string
  title: string
  rel: string
  c1: string
  c2: string
  close: number // 0~1, 나와의 가까움
  tip: string
  dos: string[]
  donts: string[]
  dept?: string | null    // 부서 id (내 회사)
  boss?: string           // 상사 person id (또는 'me')
  level?: number          // 직급 단계 1~5
  aliases?: string[]      // 일기에서 부르는 말(AI에 보낼 때 마스킹)
  company?: string | null // 외부 조직(고객사) id. 없거나 null = 내 회사
}
export interface Link { a: string; b: string; type: 'friend' | 'work' | 'tension'; note: string }
export interface Dept { id: string; name: string }
export interface Company { id: string; name: string } // 외부 조직(고객사·협력사). 내 회사는 이 목록에 없음

export const PEOPLE: Person[] = [
  { id: 'kim', name: '김부장', title: '팀장', rel: '상사', c1: '#FFB36B', c2: '#F2714F', close: 0.55,
    tip: '결론부터 말하면 잘 통해요. 숫자로 근거를 대면 신뢰합니다.',
    dos: ['첫 줄에 결론', '숫자로 근거'], donts: ['서론 길게', '돌려 말하기'] },
  { id: 'park', name: '박선임', title: '개발 리드', rel: '동료', c1: '#8FD3A6', c2: '#3DBE8B', close: 0.78,
    tip: '맥락을 먼저 깔아 주면 편해합니다. 급하게 재촉하면 역효과.',
    dos: ['배경 먼저', '선택지 제시'], donts: ['급한 재촉'] },
  { id: 'jung', name: '정사원', title: '기획', rel: '후배', c1: '#BdB4FF', c2: '#8A7CF0', close: 0.62,
    tip: '칭찬에 약해요. 구체적으로 짚어 주면 동기부여가 됩니다.',
    dos: ['구체적 칭찬', '다음 행동 제안'], donts: ['뭉뚱그린 지적'] },
  { id: 'yoon', name: '윤대리', title: '타부서', rel: '타부서', c1: '#9AD0E8', c2: '#4FA7D8', close: 0.4,
    tip: '요청은 이유와 마감을 함께. 모호하면 뒤로 밀립니다.',
    dos: ['이유 + 마감', '한 번에 정리'], donts: ['모호한 부탁'] },
  // 외부 조직(고객사) 예시 — 내 회사 사람과 한 지도에서 다른 영역/색으로 보인다
  { id: 'oh', name: '오차장', title: '구매팀', rel: '거래처', c1: '#C3BFB4', c2: '#8C8678', close: 0.32,
    company: 'cli-abc', level: 3,
    tip: '거래처라 선은 지키되 신뢰가 중요해요. 약속한 일정은 꼭 지키면 신뢰가 쌓입니다.',
    dos: ['일정 먼저 확정', '근거 자료 첨부'], donts: ['사내 사정 노출', '구두 약속'] },
]

export const COMPANIES: Company[] = [
  { id: 'cli-abc', name: '거래처 ABC' },
]

export const LINKS: Link[] = [
  { a: 'jung', b: 'yoon', type: 'friend', note: '요즘 친해 보임' },
  { a: 'kim', b: 'park', type: 'tension', note: '요즘 부딪힘' },
  { a: 'yoon', b: 'oh', type: 'work', note: '납품 건으로 자주 연락' },
]
